/* Geschenkbox-Baukasten (Roadmap 3.155 Paket 3) - sections/mhsys-gbk-baukasten.liquid, snippets/mhsys-gbk-schuber.liquid.
 *
 * Stand der Box im Browser (sessionStorage, ein Schlüssel), Rechnung „passt noch“ aus dem Platz je Artikel (custom.box_platz aus mhsys - der
 * Kunde sieht keine Zahl, Korrektur 1), Schuber mit drei Ständen, ein /cart/add.js je Box. Vertrag mit dem Bestellimport von mhsys
 * (Moduldatei geschenkbox_baukasten.md): Leerkarton und Teile mit _box, Aufpreis/Aufkleber/Karte mit _box_zu, jede Zeile mit _quelle und
 * „Geschenkbox: <Design>“, der Leerkarton mit „Aufkleber: <Text>“, die Karte mit „Grußtext“.
 * ?box=<Kennung> lädt eine Box aus dem Warenkorb zum Bearbeiten (Korrektur 5): Speichern setzt ihre Zeilen in einem /cart/update.js auf 0
 * und legt sie mit derselben Kennung neu an.
 * Die Artikel kommen gleich nach dem Laden aus sections/mhsys-boxdaten.liquid (seitenweise, mehr als 250). Ein Artikel mit Produktoptionen ("o") öffnet vor dem
 * Hineinlegen den Schuber mit seinen Feldern (sections/mhsys-boxoption.liquid, assets/mhsys-produktoptionen.js, beides erst beim ersten Mal): Eingaben stehen an
 * der Zeile des Teils, Aufpreise als eigene Zeile mit _box_zu, _box_aufpreis am Teil nennt ihre Varianten fürs Bearbeiten.
 * Kein Dauerskript: es läuft nur auf Klick; Bilder der Produktlisten mit loading="lazy".
 */
(function () {
  'use strict';
  var wurzel = document.querySelector('[data-mhsys-gbk]');
  var datenEl = wurzel && wurzel.querySelector('script[data-gbk-daten]');
  if (!datenEl) return;
  var D;
  try { D = JSON.parse(datenEl.textContent); } catch (e) { return; }

  var BOX = 100;
  /* Bestellen geht ab einem Artikel (Inhaber 02.11.2026: „keine Mindestmenge“); die Zahl sagt nur, ab wann der Satz im Schuber „fast voll“ meint */
  var FAST_VOLL = 70;
  var QUELLE = 'geschenkbox-baukasten';
  var SPEICHER = 'mhsys-gbk-box';
  var $ = function (sel, el) { return (el || wurzel).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || wurzel).querySelectorAll(sel)); };
  var schuber = $('[data-gbk-schuber]');
  var artikelNach = {}, artikelDa = false, wartenderKorb = [], boxLaedt = false;
  D.artikel = [];
  /* Sorten eines Artikels aus Produkttyp und Handle, er kann in mehreren stehen; die letzte Sorte ist „Weitere“ - nichts fällt still weg */
  function enthaelt(liste, wert) { return String(liste || '').split(',').some(function (t) { return t.trim() === wert; }); }
  function sortenVon(a) {
    var treffer = [];
    for (var i = 0; i < D.sorten.length - 1; i++) {
      /* „w“: Sorte „Mit Wunschname“ sammelt jeden Artikel mit Textfeld in den Produktoptionen (sections/mhsys-boxdaten.liquid) */
      if (enthaelt(D.sorten[i].ty, a.ty) || enthaelt(D.sorten[i].h, a.h) || (D.sorten[i].w && a.w)) treffer.push(i);
    }
    return treffer.length ? treffer : [D.sorten.length - 1];
  }
  function artikelLaden() {
    function seite(n) {
      return fetch(D.kollektion + '?section_id=mhsys-boxdaten&page=' + n).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-box-daten]');
        return el ? JSON.parse(el.textContent) : Promise.reject();
      });
    }
    /* Alle Seiten gleichzeitig (Korrektur 8): die Zahl rechnet die Seite beim Ausliefern aus; meldet Seite 1 mehr, kommt der Rest danach */
    var bekannt = Math.max(1, Number(D.seiten) || 1), auftraege = [];
    for (var n = 1; n <= bekannt; n++) auftraege.push(seite(n));
    return Promise.all(auftraege).then(function (r) {
      var rest = [];
      for (var m = bekannt + 1; m <= r[0].seiten; m++) rest.push(seite(m));
      return Promise.all(rest).then(function (r2) { return r.concat(r2); });
    }).then(function (seiten) {
      seiten.forEach(function (s) {
        s.artikel.forEach(function (a) {
          if (artikelNach[String(a.v)]) return;
          a.ss = sortenVon(a);
          artikelNach[String(a.v)] = a;
          D.artikel.push(a);
        });
      });
      artikelDa = true;
    });
  }

  var MIT_CENT = /\{\{\s*amount(_with_comma_separator|_with_apostrophe_separator)?\s*\}\}/;
  function geld(cent) {
    var format = (window.mhsysShop && window.mhsysShop.geldFormat) || '{{amount_with_comma_separator}} €';
    return format.replace(MIT_CENT, function (_, art) {
      var t = (cent / 100).toFixed(2).split('.');
      var z = art === '_with_comma_separator' ? ['.', ','] : art ? ["'", '.'] : [',', '.'];
      return t[0].replace(/\B(?=(\d{3})+(?!\d))/g, z[0]) + z[1] + t[1];
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function standardDesign() { var b = $('[data-gbk-design][aria-checked="true"]'); return b ? Number(b.dataset.gbkDesign) : 0; }

  /* --- Zustand ------------------------------------------------------------------------------------------------------- */
  function leer() { return { stufe: 'box', sorte: null, design: standardDesign(), aufkleber: -1, karte: -1, grusstext: '', korb: [], fehlt: [], bearbeite: null }; }
  var stand = leer();
  function speichern() {
    if (stand.bearbeite || !artikelDa) return;   /* eine geladene Box gehört dem Warenkorb; vor den Artikeln steht der gespeicherte Korb noch aus */
    try { sessionStorage.setItem(SPEICHER, JSON.stringify({ design: stand.design, aufkleber: stand.aufkleber, karte: stand.karte, grusstext: stand.grusstext, korb: stand.korb, stufe: stand.stufe })); } catch (e) {}
  }
  function laden() {
    try {
      var s = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null');
      if (!s) return;
      stand.design = s.design < D.designs.length ? s.design : stand.design;
      stand.aufkleber = s.aufkleber < D.aufkleber.length ? s.aufkleber : -1;
      stand.karte = s.karte < D.karten.length ? s.karte : -1;
      stand.grusstext = String(s.grusstext || '').slice(0, 120);
      wartenderKorb = s.korb || [];   /* kommt in den Korb, sobald die Artikel da sind */
      stand.stufe = s.stufe === 'fuellen' ? 'fuellen' : 'box';
    } catch (e) {}
  }

  function belegt() { return stand.korb.reduce(function (s, k) { var a = artikelNach[String(k.v)]; return s + (a ? a.pl * k.n : 0); }, 0); }
  function passt(a) { return a.pl > 0 && a.pl <= BOX - belegt(); }
  function inSorte(i) { return D.artikel.filter(function (a) { return a.ss.indexOf(i) >= 0; }); }
  function sortePasst(i) { return inSorte(i).some(passt); }
  function stueck(i) { return stand.korb.reduce(function (s, k) { var a = artikelNach[String(k.v)]; return s + (a && a.ss.indexOf(i) >= 0 ? k.n : 0); }, 0); }
  function menge(v) { return stand.korb.reduce(function (s, k) { return s + (String(k.v) === String(v) ? k.n : 0); }, 0); }
  /* Was am Teil steht, zum Lesen: „Anton · Hirsch“ (Versteckte mit _ nicht) */
  function eingaben(k) { return Object.keys(k.e || {}).filter(function (q) { return q.charAt(0) !== '_'; }).map(function (q) { return k.e[q]; }).join(' · '); }
  function aufpreis(k) { return (k.z || []).reduce(function (s, z) { return s + z.pr; }, 0); }
  function summe() {
    var d = D.designs[stand.design], s = D.box.pr + (d ? d.pr : 0);
    if (stand.aufkleber >= 0) s += D.aufkleber[stand.aufkleber].pr;
    if (stand.karte >= 0) s += D.karten[stand.karte].pr;
    stand.korb.forEach(function (k) { var a = artikelNach[String(k.v)]; if (a) s += (a.pr + aufpreis(k)) * k.n; });
    return s;
  }
  function name(a) { return a.t + (a.vt ? ' – ' + a.vt : ''); }

  /* Ein Teil hinein: gleicher Artikel mit gleichen Eingaben zählt hoch, ein anderer Wunschtext ist eine eigene Zeile. $e Eingaben, $z Aufpreise [{id, f, pr}] */
  function hineinlegen(a, e, z) {
    if (!passt(a)) return false;
    var schluessel = JSON.stringify(e || {});
    var k = stand.korb.find(function (x) { return String(x.v) === String(a.v) && JSON.stringify(x.e || {}) === schluessel; });
    if (!k) {
      k = { v: a.v, n: 0 };
      if (e && Object.keys(e).length) k.e = e;
      if (z && z.length) k.z = z;
      stand.korb.push(k);
    }
    return korbAendern(k, 1);
  }
  function korbAendern(k, d) {
    var a = artikelNach[String(k.v)];
    if (d > 0 && (!a || !passt(a))) return false;
    k.n += d;
    if (k.n <= 0) stand.korb = stand.korb.filter(function (x) { return x !== k; });
    if (d > 0) { schuber.classList.remove('mhsys-gbk-schuber--puls'); void schuber.offsetWidth; schuber.classList.add('mhsys-gbk-schuber--puls'); }
    speichern();
    return true;
  }

  /* Korrektur 7: ein Tipp auf „+“ oder „Rein damit“, wenn das Stück nicht mehr passt, bleibt nicht stumm */
  var VOLL_SATZ = 'Des passt nimma in die Box – nimm erst was raus.';
  var meldungZeit = 0;
  function melden(text) {
    var m = $('[data-gbk-meldung]');
    m.textContent = text;
    m.classList.add('mhsys-gbk__meldung--an');
    clearTimeout(meldungZeit);
    meldungZeit = setTimeout(function () { m.classList.remove('mhsys-gbk__meldung--an'); }, 2400);
  }

  /* --- Stufen und Sorten --------------------------------------------------------------------------------------------- */
  function stufeZeigen(st, fokus) {
    stand.stufe = st;
    $$('[data-gbk-stufe]').forEach(function (t) { t.hidden = t.dataset.gbkStufe !== st; });
    $$('.mhsys-gbk__stufe').forEach(function (b) {
      var an = b.dataset.gbkZu === st;
      if (an) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.classList.toggle('mhsys-gbk__stufe--fertig', st === 'fuellen' && b.dataset.gbkZu === 'box');
    });
    if (st === 'fuellen') sorteZeigen(stand.sorte);
    bandMalen();
    speichern();
    if (fokus) $('.mhsys-gbk__stufen').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function sortenMalen() {
    var laedt = $('[data-gbk-laedt]');
    if (laedt) laedt.hidden = artikelDa;
    if (!artikelDa) return;
    $$('[data-gbk-sorte]').forEach(function (b) {
      var i = Number(b.dataset.gbkSorte), alle = inSorte(i), n = stueck(i), ok = sortePasst(i);
      b.hidden = alle.length === 0;
      b.classList.toggle('mhsys-gbk__sorte--hat', n > 0);
      b.classList.toggle('mhsys-gbk__sorte--aus', !ok);
      var drin = $('[data-gbk-drin]', b);
      drin.hidden = n === 0;
      drin.textContent = n;
      b.setAttribute('aria-label', (D.sorten[i] ? D.sorten[i].t : '') + (n ? ', ' + n + ' drin' : '') + (ok ? '' : ', passt nimma nei'));
    });
    /* Ein Kasten, dessen Sorten alle leer sind, verschwindet samt Überschrift */
    $$('.mhsys-gbk__sortenblock').forEach(function (k) { k.hidden = !k.querySelector('[data-gbk-sorte]:not([hidden])'); });
  }

  function sorteZeigen(i) {
    stand.sorte = i;
    var liste = $('[data-gbk-sortenansicht]'), uebersicht = $('[data-gbk-sorten]');
    if (i === null || i === undefined) {
      liste.hidden = true; uebersicht.hidden = false;
      sortenMalen();
      return;
    }
    uebersicht.hidden = true; liste.hidden = false;
    $('[data-gbk-sortetitel]').textContent = D.sorten[i] ? D.sorten[i].t : '';
    $('[data-gbk-sorteunter]').textContent = D.sorten[i] ? D.sorten[i].x : '';
    leisteMalen(i);
    kachelnMalen(i);
  }
  /* Eine Kachel je Produkt, die Größe wählt man in der Kachel (Inhaber 02.11.2026: die Listen waren viel zu lang); $wahl hält die gewählte Größe je Produkt */
  function kachelnMalen(i, wahl) {
    var nachProdukt = {}, produkte = [];
    inSorte(i).forEach(function (a) {
      if (!nachProdukt[a.h]) { nachProdukt[a.h] = []; produkte.push(nachProdukt[a.h]); }
      nachProdukt[a.h].push(a);
    });
    $('[data-gbk-artikel]').innerHTML = produkte.map(function (varianten) { return kachel(varianten, wahl && wahl[varianten[0].h]); }).join('');
  }

  function kachel(varianten, gewaehlt) {
      var a = varianten.find(function (x) { return String(x.v) === String(gewaehlt); }) || varianten.find(function (x) { return menge(x.v) > 0; }) || varianten[0];
      var mehrere = varianten.length > 1, titel = mehrere ? a.t : name(a);
      var ok = passt(a), n = menge(a.v);
      var aus = ok ? '' : ' aria-disabled="true"', txt = ok ? (n ? 'No oans nei' : 'Rein damit') : 'Passt nimma nei';
      return '<div class="mhsys-gbk__art' + (n ? ' mhsys-gbk__art--gewaehlt' : '') + (ok ? '' : ' mhsys-gbk__art--voll') + '">'
        + '<button type="button" class="mhsys-gbk__artinfo" data-gbk-info="' + esc(a.v) + '" aria-label="Infos zu ' + esc(name(a)) + '">'
        + '<span class="mhsys-gbk__artbild">' + (a.b ? '<img src="' + esc(a.b) + '" alt="" width="200" height="200" loading="lazy">' : '') + '</span>'
        + '<span class="mhsys-gbk__artname">' + esc(titel) + '</span></button>'
        + (mehrere ? '<select class="mhsys-gbk__artwahl" data-gbk-wahl aria-label="Ausführung von ' + esc(a.t) + '">' + varianten.map(function (x) {
          return '<option value="' + esc(x.v) + '"' + (x === a ? ' selected' : '') + '>' + esc(x.vt || '') + '</option>'; }).join('') + '</select>' : '')
        + '<span class="mhsys-gbk__artpreis">' + esc(geld(a.pr)) + '</span>'
        + '<span class="mhsys-gbk__artgp">' + (a.gp ? esc(a.gp) : '') + '</span>'
        + '<button type="button" class="mhsys-gbk__artmehr" data-gbk-info="' + esc(a.v) + '" aria-label="Mehr Infos zu ' + esc(name(a)) + '">Mehr Infos</button>'
        + '<button type="button" class="mhsys-gbk__artknopf" data-gbk-art="' + esc(a.v) + '"' + aus + '>' + txt + '</button></div>';
  }

  /* Die Leiste über den Produkten: einmal gebaut, danach nur der Stand; die aktuelle Sorte rückt in die Mitte */
  function leisteMalen(i) {
    var l = $('[data-gbk-leiste]');
    if (!l.firstElementChild) {
      l.innerHTML = '<button type="button" class="mhsys-gbk__chip" data-gbk-alle>← Alle</button>' + D.sorten.map(function (s, n) {
        return inSorte(n).length ? '<button type="button" class="mhsys-gbk__chip" data-gbk-zu-sorte="' + n + '">' + esc(s.t) + '</button>' : '';
      }).join('');
    }
    $$('[data-gbk-zu-sorte]', l).forEach(function (b) {
      var n = Number(b.dataset.gbkZuSorte);
      if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      b.classList.toggle('mhsys-gbk__chip--drin', stueck(n) > 0);
    });
    var jetzt = l.querySelector('[aria-current]');
    if (jetzt) l.scrollLeft = jetzt.offsetLeft - l.offsetLeft - (l.clientWidth - jetzt.offsetWidth) / 2;
  }

  /* --- Schuber -------------------------------------------------------------------------------------------------------- */
  function satz(p) {
    if (p === 0) return 'Noch leer – fang am besten mit was Großem an.';
    if (p < FAST_VOLL) return 'Da passt no einiges nei.';
    if (D.artikel.some(passt)) return 'Schaut guad aus! A Kleinigkeit geht no.';
    return 'Randvoll – mehr geht ned nei!';
  }
  function huelle() {
    var d = D.designs[stand.design];
    var t = 'Box „' + (d ? d.w : '') + '“' + (stand.aufkleber >= 0 ? ' · Aufkleber „' + D.aufkleber[stand.aufkleber].w + '“' : ' · ohne Aufkleber');
    if (stand.karte >= 0) {
      t += ' · ' + D.karten[stand.karte].t;
      if (stand.grusstext) t += ' · „' + stand.grusstext.slice(0, 40) + (stand.grusstext.length > 40 ? '…' : '') + '“';
    } else { t += ' · ohne Grußkarte'; }
    return t;
  }
  function bandMalen() { $('[data-gbk-fertigband]').hidden = belegt() <= 0 || stand.stufe !== 'fuellen'; }
  function schuberMalen() {
    var p = belegt();
    bandMalen();
    $('[data-gbk-stand]').textContent = p === 0 ? 'noch leer' : (p < FAST_VOLL ? 'da passt no was nei' : (D.artikel.some(passt) ? 'fast voll' : 'randvoll'));
    var balken = $('[data-gbk-balken]');
    balken.style.width = Math.min(100, p) + '%';
    balken.classList.toggle('mhsys-gbk-schuber__fuell--genug', p > 0);
    $('[data-gbk-summe]').textContent = geld(summe());
    $('[data-gbk-summe-gross]').textContent = geld(summe());
    $('[data-gbk-satz]').textContent = satz(p);
    $('[data-gbk-huelle]').textContent = huelle();
    var zeilen = stand.korb.map(function (k, i) {
      var a = artikelNach[String(k.v)];
      return '<li class="mhsys-gbk-schuber__zeile">' + (a.b ? '<img src="' + esc(a.b) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="mhsys-gbk-schuber__ohnebild"></span>')
        + '<span class="mhsys-gbk-schuber__name">' + esc(name(a)) + (eingaben(k) ? '<small>„' + esc(eingaben(k)) + '“</small>' : '') + '<small>' + esc(geld((a.pr + aufpreis(k)) * k.n)) + (a.gp ? ' · ' + esc(a.gp) : '') + '</small></span>'
        + '<span class="mhsys-gbk-schuber__menge"><button type="button" data-gbk-k="' + i + '" data-gbk-d="-1" aria-label="' + esc(name(a)) + ': eins weniger">−</button><b>' + k.n + '</b>'
        + '<button type="button" data-gbk-k="' + i + '" data-gbk-d="1" aria-label="' + esc(name(a)) + ': eins mehr"' + (passt(a) ? '' : ' aria-disabled="true"') + '>+</button></span>'
        + '<button type="button" class="mhsys-gbk-schuber__weg" data-gbk-k="' + i + '" data-gbk-d="weg" aria-label="' + esc(name(a)) + ' entfernen">✕</button></li>';
    });
    stand.fehlt.forEach(function (f) {
      zeilen.push('<li class="mhsys-gbk-schuber__zeile mhsys-gbk-schuber__zeile--fehlt"><span class="mhsys-gbk-schuber__ohnebild"></span><span class="mhsys-gbk-schuber__name">' + esc(f.t)
        + '<small>gibt\'s grad ned – bitte tauschen</small></span><button type="button" class="mhsys-gbk-schuber__weg" data-gbk-fehlt="' + esc(f.v) + '" aria-label="' + esc(f.t) + ' entfernen">✕</button></li>');
    });
    $('[data-gbk-liste]').innerHTML = zeilen.length ? zeilen.join('') : '<li class="mhsys-gbk-schuber__leer">Noch nix drin – such dir oben was aus.</li>';
    $('[data-gbk-alter]').hidden = !stand.korb.some(function (k) { var a = artikelNach[String(k.v)]; return a && a.a; });
    var bereit = p > 0 && p <= BOX && stand.fehlt.length === 0;
    $$('[data-gbk-kaufen]').forEach(function (b) {
      b.disabled = !bereit;
      b.textContent = !bereit ? (stand.fehlt.length ? 'Erst tauschen, dann speichern' : p > BOX ? 'Box is z\'voll – nimm erst was raus' : 'Leg erst was nei, dann kannst bestellen')
        : (stand.bearbeite ? 'Box im Warenkorb aktualisieren' : 'Ins Eikaffskerberl');
    });
    $('[data-gbk-bearb]').hidden = !stand.bearbeite && !boxLaedt;
    $('[data-gbk-bearb]').classList.toggle('mhsys-gbk__bearb--laedt', boxLaedt);
    $('[data-gbk-bearb-text]').textContent = boxLaedt ? 'Moment, deine Box wird geladen …' : 'Du bearbeitest a Box aus deinem Eikaffskerberl.';
  }

  var ausloeser = null;
  function schuberStand(st, von) {
    if (st !== 'zu' && schuber.dataset.stand === 'zu') ausloeser = von || document.activeElement;
    schuber.dataset.stand = st;
    var auf = $('[data-gbk-auf]');
    auf.setAttribute('aria-expanded', st !== 'zu' ? 'true' : 'false');
    auf.setAttribute('aria-label', st === 'zu' ? 'Box aufklappen' : 'Box zuklappen');
    document.documentElement.classList.toggle('mhsys-gbk-voll', st === 'voll');
    if (st === 'zu' && ausloeser && document.contains(ausloeser)) { ausloeser.focus({ preventScroll: true }); ausloeser = null; }
    if (st === 'voll') { var erst = $('[data-gbk-inhalt] button:not([disabled])'); if (erst) erst.focus({ preventScroll: true }); }
  }

  /* Sorten nur zeichnen, wenn „Befüllen“ zu sehen ist - in Stufe 1 sind sie verborgen (spart beim Laden einen langen Task) */
  function alles() { if (stand.stufe === 'fuellen') sorteZeigen(stand.sorte); schuberMalen(); }

  /* --- Stufe 1: Design, Aufkleber, Karte ----------------------------------------------------------------------------- */
  function wahlMalen() {
    $$('[data-gbk-design]').forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.gbkDesign) === stand.design ? 'true' : 'false'); });
    $$('[data-gbk-aufkleber]').forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.gbkAufkleber) === stand.aufkleber ? 'true' : 'false'); });
    $$('[data-gbk-karte]').forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.gbkKarte) === stand.karte ? 'true' : 'false'); });
    karteZeigen();
    var gt = $('[data-gbk-grusstext]');
    if (gt) {
      gt.hidden = stand.karte < 0;
      var feld = $('[data-gbk-gt]');
      if (feld.value !== stand.grusstext) feld.value = stand.grusstext;
      $('[data-gbk-gt-zaehler]').textContent = stand.grusstext.length + ' / 120';
    }
  }
  /* Pfeiltasten in den Auswahlgruppen (role=radiogroup) */
  /* Die gewählte Karte steht als eine Zeile auf der Seite; ausgesucht wird im Schuber von unten */
  function karteZeigen() {
    var name = $('[data-gbk-karte-name]');
    if (!name) return;
    var kachel = stand.karte >= 0 ? $('[data-gbk-karte="' + stand.karte + '"]') : null;
    var img = kachel ? kachel.querySelector('img') : null, feld = $('[data-gbk-karte-bild]'), pr = kachel ? kachel.querySelector('.mhsys-gbk__kartenpreis') : null;
    name.textContent = kachel ? kachel.querySelector('.mhsys-gbk__kartenname').textContent : 'ohne Karte';
    $('[data-gbk-karte-preis]').textContent = pr ? pr.textContent : '';
    $('[data-gbk-karte-aktion]').textContent = kachel ? 'Ändern' : 'Karte aussuchen';
    feld.hidden = !img;
    feld.innerHTML = '';
    if (img) { var kopie = new Image(); kopie.src = img.getAttribute('src'); kopie.alt = ''; feld.appendChild(kopie); }
  }
  var blatt = $('[data-gbk-kartenblatt]');
  $$('.mhsys-gbk__blatt').forEach(function (b) {
    b.addEventListener('close', function () { if (!$('.mhsys-gbk__blatt[open]')) document.documentElement.classList.remove('mhsys-gbk-blatt'); });
    /* Ein Tipp neben den Schuber schließt ihn (der Hintergrund gehört zum Dialog selbst) */
    b.addEventListener('click', function (e) { if (e.target === b) b.close(); });
  });
  function blattOeffnen(b) { document.documentElement.classList.add('mhsys-gbk-blatt'); b.showModal(); }

  /* Infos zu einem Artikel: Schuber von unten, Inhalt aus sections/mhsys-boxinfo.liquid, erst beim Antippen und nur einmal je Artikel */
  var infoBlatt = $('[data-gbk-info-blatt]'), infoSpeicher = {}, infoGerade = null;
  function infoEinsetzen(knoten) {
    var lauf = $('[data-gbk-info-lauf]');
    lauf.innerHTML = '';
    lauf.appendChild(knoten);
    lauf.scrollTop = 0;
  }
  function infoOeffnen(v) {
    var a = artikelNach[v];
    if (!a || !infoBlatt) return;
    infoGerade = v;
    var ok = passt(a), rein = $('[data-gbk-info-rein]');
    $('[data-gbk-info-titel]').textContent = name(a);
    $('[data-gbk-info-preis]').textContent = geld(a.pr) + (a.gp ? ' · ' + a.gp : '');
    rein.setAttribute('data-gbk-art', v);
    rein.textContent = ok ? (menge(a.v) ? 'No oans nei' : 'Rein damit') : 'Passt nimma nei';
    if (ok) rein.removeAttribute('aria-disabled'); else rein.setAttribute('aria-disabled', 'true');
    blattOeffnen(infoBlatt);
    if (infoSpeicher[v]) { infoEinsetzen(infoSpeicher[v]); return; }
    var warten = document.createElement('p');
    warten.textContent = 'Moment …';
    infoEinsetzen(warten);
    var ziel = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(a.h);
    fetch(ziel + '?section_id=mhsys-boxinfo').then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gbk-info-inhalt]');
      if (!el) return Promise.reject();
      infoSpeicher[v] = el;
      if (infoGerade === v) infoEinsetzen(el);
    }).catch(function () {
      if (infoGerade !== v) return;
      var link = document.createElement('a');
      link.href = ziel; link.target = '_blank'; link.rel = 'noopener'; link.setAttribute('data-boxinfo-link', '');
      link.textContent = 'Zum Produkt';
      infoEinsetzen(link);
    });
  }

  /* Produktoptionen eines Artikels: Skript und CSS der Optionen laden erst beim ersten Mal, die Felder je Öffnen frisch vom Server */
  var optionBlatt = $('[data-gbk-option-blatt]'), optionGerade = null, poBereit = null;
  function poLaden() {
    if (poBereit) return poBereit;
    poBereit = new Promise(function (ja, nein) {
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = D.po.css;
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = D.po.js; js.onload = ja; js.onerror = nein;
      document.head.appendChild(js);
    });
    return poBereit;
  }
  function optionOeffnen(a) {
    var lauf = $('[data-gbk-option-lauf]'), rein = $('[data-gbk-option-rein]');
    optionGerade = a;
    $('[data-gbk-option-titel]').textContent = name(a);
    $('[data-gbk-option-preis]').textContent = geld(a.pr) + (a.gp ? ' · ' + a.gp : '');
    lauf.innerHTML = '<p>Moment …</p>';
    rein.disabled = true;
    blattOeffnen(optionBlatt);
    var ziel = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(a.h);
    Promise.all([fetch(ziel + '?section_id=mhsys-boxoption').then(function (r) { return r.ok ? r.text() : Promise.reject(); }), poLaden()]).then(function (e) {
      if (optionGerade !== a || !optionBlatt.open) return;
      var huelle = new DOMParser().parseFromString(e[0], 'text/html').querySelector('[data-boxoption]');
      if (!huelle) return Promise.reject();
      lauf.innerHTML = '';
      lauf.appendChild(document.importNode(huelle, true));
      var form = lauf.querySelector('form');
      /* Ohne Felder (Theme-Schalter aus, Metafeld leer): schlicht hinein */
      if (!form.querySelector('[data-mhsys-po]')) { optionBlatt.close(); gelegt(a); return; }
      form.addEventListener('mhsys-po:gueltig', function (ev) {
        optionBlatt.close();
        gelegt(a, ev.detail.eigenschaften, ev.detail.aufpreis.map(function (z) { return { id: z.id, f: z.feldname, pr: Math.round(z.preis * 100) }; }));
      });
      form.addEventListener('submit', function (ev) { ev.preventDefault(); });
      window.mhsysPoEinrichten();
      rein.disabled = false;
      /* Nichts zum Ausfüllen, nur eine feste Wahl (Einweg-Pfand): gleich hinein, der Aufpreis geht mit */
      if (!form.querySelector('input:not([type="hidden"]), select, textarea')) form.requestSubmit();
    }).catch(function () {
      if (optionGerade !== a) return;
      lauf.innerHTML = '<p>Das geht grad ned – probier\'s bitte glei no amal.</p>';
    });
  }
  /* Hineinlegen und in der Sorte an derselben Stelle bleiben (Korrektur 11, Inhaber 02.11.2026 - vorher ging es zurück zur Übersicht): die Kachel steht
     nach dem Neuzeichnen dort, wo sie war - auch wenn darüber das Band „Schaut guad aus“ erscheint -, und der Fokus bleibt auf ihrem Knopf */
  function gelegt(a, e, z) {
    if (!hineinlegen(a, e, z)) { melden(VOLL_SATZ); return; }
    var alt = $('[data-gbk-artikel] [data-gbk-art="' + a.v + '"]'), oben = alt ? alt.getBoundingClientRect().top : null, wahl = {};
    $$('[data-gbk-artikel] [data-gbk-wahl]').forEach(function (w) { var x = artikelNach[w.value]; if (x) wahl[x.h] = x.v; });
    if (stand.sorte !== null && stand.sorte !== undefined) { kachelnMalen(stand.sorte, wahl); leisteMalen(stand.sorte); }
    schuberMalen();
    var neu = $('[data-gbk-artikel] [data-gbk-art="' + a.v + '"]');
    if (neu) {
      if (oben !== null) window.scrollBy(0, neu.getBoundingClientRect().top - oben);
      neu.focus({ preventScroll: true });
    }
    melden(name(a) + ' is drin ✓');
  }

  function pfeile(e, sel, nurFokus) {
    if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
    var knoepfe = $$(sel, e.currentTarget), i = knoepfe.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var n = knoepfe[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : knoepfe.length - 1)) % knoepfe.length];
    n.focus();
    if (!nurFokus) n.click();
  }

  /* --- In den Warenkorb ---------------------------------------------------------------------------------------------- */
  function kennung() { return 'b-' + Math.random().toString(36).slice(2, 8); }
  function zeilen(k) {
    var d = D.designs[stand.design] || { w: '' };
    var basis = function (art) { var p = { Geschenkbox: d.w, _quelle: QUELLE }; p[art] = k; return p; };
    var leerkarton = basis('_box');
    if (stand.aufkleber >= 0) leerkarton.Aufkleber = D.aufkleber[stand.aufkleber].w;
    var items = [{ id: Number(D.box.v), quantity: 1, properties: leerkarton }];
    if (d.pr > 0 && d.v) items.push({ id: Number(d.v), quantity: 1, properties: basis('_box_zu') });
    if (stand.aufkleber >= 0 && D.aufkleber[stand.aufkleber].v) items.push({ id: Number(D.aufkleber[stand.aufkleber].v), quantity: 1, properties: basis('_box_zu') });
    if (stand.karte >= 0) {
      var kp = basis('_box_zu');
      if (stand.grusstext.trim()) kp['Grußtext'] = stand.grusstext.trim();
      items.push({ id: Number(D.karten[stand.karte].v), quantity: 1, properties: kp });
    }
    stand.korb.forEach(function (x) {
      var p = basis('_box');
      Object.keys(x.e || {}).forEach(function (q) { p[q] = x.e[q]; });
      if (x.z && x.z.length) p._box_aufpreis = x.z.map(function (z) { return z.id; }).join(',');
      items.push({ id: Number(x.v), quantity: x.n, properties: p });
      (x.z || []).forEach(function (z) {
        var zu = basis('_box_zu');
        zu._gpo_field_name = z.f;
        items.push({ id: Number(z.id), quantity: x.n, properties: zu });
      });
    });
    return items;
  }
  function route(art) {
    var r = window.mhsysShop || {};
    var u = { add: r.warenkorbHinzufuegenUrl || '/cart/add', update: r.warenkorbSetzenUrl || '/cart/update' }[art];
    return (u + '.js').replace(/\.js\.js$/, '.js');
  }
  function senden(url, koerper) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(koerper) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Das hat leider nicht geklappt.'); return j; }); });
  }
  var sendetGerade = false;
  function kaufen() {
    if (sendetGerade || belegt() <= 0 || stand.fehlt.length) return;
    sendetGerade = true;
    var fehler = $('[data-gbk-fehler]');
    fehler.hidden = true;
    $$('[data-gbk-kaufen]').forEach(function (b) { b.disabled = true; });
    var k = stand.bearbeite || kennung();
    var vorher = Promise.resolve();
    if (stand.bearbeite) {
      /* Die alten Zeilen dieser Box in einem Schritt auf 0 - dann neu mit derselben Kennung, nichts doppelt */
      vorher = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (korb) {
        var updates = {};
        korb.items.forEach(function (i) { var p = i.properties || {}; if (p._box === k || p._box_zu === k) updates[i.key] = 0; });
        return Object.keys(updates).length ? senden(route('update'), { updates: updates }) : null;
      });
    }
    var war = !!stand.bearbeite;
    vorher.then(function () { return senden(route('add'), { items: zeilen(k) }); }).then(function () {
      try { sessionStorage.removeItem(SPEICHER); } catch (e) {}
      stand = leer();
      if (war) adresseOhneBox();
      wahlMalen(); stufeZeigen('box'); schuberStand('zu'); alles();
      melden(war ? 'Box im Warenkorb aktualisiert ✓' : 'Deine Box liegt im Eikaffskerberl ✓');
    }).catch(function (e) {
      fehler.textContent = e.message || 'Das hat leider nicht geklappt – bitte probier\'s no amal.';
      fehler.hidden = false;
      schuberMalen();
    }).then(function () { sendetGerade = false; });
  }

  /* Box aus dem Warenkorb laden (?box=<Kennung>, Korrektur 5); den Warenkorb holt der Start gleichzeitig mit den Artikeln (Korrektur 8) */
  function ausWarenkorb(k, korbHolen) {
    return korbHolen.then(function (korb) {
      var gefunden = false;
      var neu = leer();
      neu.bearbeite = k; neu.stufe = 'fuellen';
      korb.items.forEach(function (i) {
        var p = i.properties || {};
        if (p._box === k) {
          gefunden = true;
          if (String(i.variant_id) === String(D.box.v)) {
            D.designs.forEach(function (d, n) { if (d.w === p.Geschenkbox) neu.design = n; });
            D.aufkleber.forEach(function (a, n) { if (a.w === p.Aufkleber) neu.aufkleber = n; });
          } else if (artikelNach[String(i.variant_id)]) {
            var ein = { v: i.variant_id, n: i.quantity }, e = {};
            Object.keys(p).forEach(function (q) { if (['Geschenkbox', '_box', '_quelle', '_box_aufpreis'].indexOf(q) < 0) e[q] = p[q]; });
            if (Object.keys(e).length) ein.e = e;
            if (p._box_aufpreis) {
              ein.z = String(p._box_aufpreis).split(',').map(function (id) {
                var z = korb.items.find(function (x) { return String(x.variant_id) === id && (x.properties || {})._box_zu === k; });
                return { id: id, f: z ? (z.properties._gpo_field_name || '') : '', pr: z ? z.price : 0 };
              });
            }
            neu.korb.push(ein);
          } else {
            neu.fehlt.push({ v: i.variant_id, t: i.product_title });
          }
        } else if (p._box_zu === k) {
          D.karten.forEach(function (c, n) { if (String(c.v) === String(i.variant_id)) { neu.karte = n; neu.grusstext = String(p['Grußtext'] || ''); } });
        }
      });
      if (gefunden) stand = neu; else melden('Die Box is nimmer im Warenkorb – stell dir a neue zam.');
    }).catch(function () {});
  }

  /* Nur ?box= aus der Adresse nehmen - alles andere bleibt (bis Paket 5 hängt die Seite an ?view=) */
  function adresseOhneBox() {
    if (!history.replaceState) return;
    var u = new URL(location.href);
    u.searchParams.delete('box');
    history.replaceState(null, '', u.pathname + u.search);
  }

  /* --- Ereignisse ----------------------------------------------------------------------------------------------------- */
  wurzel.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !wurzel.contains(t)) return;
    if (t.dataset.gbkZu) { stufeZeigen(t.dataset.gbkZu, true); return; }
    if (t.dataset.gbkDesign !== undefined) { stand.design = Number(t.dataset.gbkDesign); wahlMalen(); schuberMalen(); speichern(); return; }
    if (t.dataset.gbkAufkleber !== undefined) { stand.aufkleber = Number(t.dataset.gbkAufkleber); wahlMalen(); schuberMalen(); speichern(); return; }
    if (t.hasAttribute('data-gbk-karten-auf')) { blattOeffnen(blatt); return; }
    if (t.hasAttribute('data-gbk-blatt-zu')) { t.closest('dialog').close(); return; }
    if (t.dataset.gbkInfo !== undefined) { infoOeffnen(t.dataset.gbkInfo); return; }
    /* Die Klappen der Pflichtangaben (mhsys-produkt.js läuft auf dieser Seite nicht) */
    if (t.hasAttribute('data-mhsys-akkordeon')) {
      var klappe = document.getElementById(t.getAttribute('aria-controls')), klappeAuf = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', klappeAuf ? 'false' : 'true');
      if (klappe) klappe.hidden = klappeAuf;
      return;
    }
    if (t.dataset.gbkKarte !== undefined) { stand.karte = Number(t.dataset.gbkKarte); if (stand.karte < 0) stand.grusstext = ''; wahlMalen(); schuberMalen(); speichern(); blatt.close(); return; }
    if (t.dataset.gbkSorte !== undefined) {
      var i = Number(t.dataset.gbkSorte);
      if (!artikelDa) { melden('Moment, die Sachen kommen glei …'); return; }
      if (!sortePasst(i)) { melden('Davon passt nix mehr nei – schau im Schuber, ob du was tauschen magst.'); return; }
      sorteZeigen(i); speichern(); $('[data-gbk-sortetitel]').focus({ preventScroll: true });
      $('.mhsys-gbk__stufen').scrollIntoView({ block: 'start' });
      return;
    }
    if (t.dataset.gbkZuSorte !== undefined) {
      sorteZeigen(Number(t.dataset.gbkZuSorte)); speichern();
      if ($('[data-gbk-sortenansicht]').getBoundingClientRect().top < 0) $('[data-gbk-sortenansicht]').scrollIntoView({ block: 'start' });
      return;
    }
    if (t.hasAttribute('data-gbk-alle')) {
      var war = stand.sorte; sorteZeigen(null); speichern();
      var z = $('[data-gbk-sorte="' + war + '"]'); if (z) z.focus({ preventScroll: true });
      if ($('[data-gbk-sorten]').getBoundingClientRect().top < 0) $('.mhsys-gbk__stufen').scrollIntoView({ block: 'start' });
      return;
    }
    if (t.dataset.gbkArt !== undefined) {
      var a = artikelNach[t.dataset.gbkArt];
      if (!a) return;
      if (infoBlatt && infoBlatt.open) infoBlatt.close();   /* auch ohne Platz: die Meldung stünde sonst hinter dem Schuber */
      if (!passt(a)) { melden(VOLL_SATZ); return; }
      if (a.o) optionOeffnen(a); else gelegt(a);
      return;
    }
    if (t.dataset.gbkK !== undefined) {
      var k = stand.korb[Number(t.dataset.gbkK)];
      if (!k) return;
      if (!korbAendern(k, t.dataset.gbkD === 'weg' ? -k.n : Number(t.dataset.gbkD))) { melden(VOLL_SATZ); return; }
      alles();
      return;
    }
    if (t.dataset.gbkFehlt !== undefined) { stand.fehlt = stand.fehlt.filter(function (f) { return String(f.v) !== t.dataset.gbkFehlt; }); schuberMalen(); return; }
    if (t.hasAttribute('data-gbk-kaufen')) { kaufen(); return; }
    if (t.hasAttribute('data-gbk-box-auf')) { schuberStand('voll', t); return; }
    if (t.hasAttribute('data-gbk-huelle-aendern')) { schuberStand('zu'); stufeZeigen('box', true); return; }
    if (t.hasAttribute('data-gbk-neu')) {
      stand = leer();
      adresseOhneBox();
      wahlMalen(); stufeZeigen('box', true); alles();
      return;
    }
    if (t.hasAttribute('data-gbk-auf')) { schuberStand(schuber.dataset.stand === 'zu' ? 'voll' : 'zu', t); return; }
  });
  /* Andere Größe in der Kachel: Preis, Bild und Knopf gelten für diese Variante */
  wurzel.addEventListener('change', function (e) {
    if (!e.target.matches('[data-gbk-wahl]')) return;
    var a = artikelNach[e.target.value], kachelEl = e.target.closest('.mhsys-gbk__art');
    if (!a || !kachelEl) return;
    var varianten = D.artikel.filter(function (x) { return x.h === a.h; });
    kachelEl.outerHTML = kachel(varianten, a.v);
    var neu = $('[data-gbk-artikel] [data-gbk-art="' + a.v + '"]');
    if (neu) neu.closest('.mhsys-gbk__art').querySelector('[data-gbk-wahl]').focus({ preventScroll: true });
  });
  $('[data-gbk-kopf]').addEventListener('click', function (e) { if (!e.target.closest('button') && schuber.dataset.stand === 'zu') schuberStand('voll'); });
  ['.mhsys-gbk__designs', '.mhsys-gbk__aufkleber'].forEach(function (sel) {
    var g = $(sel);
    if (g) g.addEventListener('keydown', function (e) { pfeile(e, 'button'); });
  });
  /* Im Schuber führen die Pfeile nur den Fokus: wählen schließt ihn */
  var kartenGruppe = $('.mhsys-gbk__karten');
  if (kartenGruppe) kartenGruppe.addEventListener('keydown', function (e) { pfeile(e, 'button', true); });
  var feld = $('[data-gbk-gt]');
  if (feld) feld.addEventListener('input', function () { stand.grusstext = feld.value.slice(0, 120); $('[data-gbk-gt-zaehler]').textContent = stand.grusstext.length + ' / 120'; schuberMalen(); speichern(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && schuber.dataset.stand !== 'zu') { schuberStand('zu'); return; }
    /* Fokusfalle im Stand „voll“ */
    if (e.key === 'Tab' && schuber.dataset.stand === 'voll') {
      var f = $$('button:not([disabled]), textarea, [href]', schuber).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      else if (!schuber.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); }
    }
  });
  /* Ziehen am Griff oder Kopf: hoch = ein Stand weiter (weit = maximieren), runter = zurück */
  (function () {
    var y0 = null;
    function start(e) { if (e.target.closest('button')) return; y0 = e.clientY; }
    function ende(e) {
      if (y0 === null) return;
      var dy = e.clientY - y0;
      y0 = null;
      if (dy < -40) schuberStand('voll');
      else if (dy > 40) schuberStand('zu');
    }
    [$('[data-gbk-griff]'), $('[data-gbk-kopf]')].forEach(function (el) { el.addEventListener('pointerdown', start); });
    window.addEventListener('pointerup', ende);
    window.addEventListener('pointercancel', function () { y0 = null; });
  })();

  /* --- Start --------------------------------------------------------------------------------------------------------- */
  var box = (new URLSearchParams(location.search).get('box') || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 40);
  var korbHolen = box ? fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }) : null;
  if (!box) laden(); else { boxLaedt = true; stand.stufe = 'fuellen'; }   /* gleich Stufe 2 und die Ladeanzeige, nicht erst Stufe 1 und dann ein Sprung */
  wahlMalen();
  stufeZeigen(stand.stufe);
  schuberMalen();
  artikelLaden().then(function () {
    if (box) return ausWarenkorb(box, korbHolen);
    stand.korb = wartenderKorb.filter(function (k) { return artikelNach[String(k.v)]; });   /* inzwischen ausverkauft: still raus */
  }).then(function () {
    boxLaedt = false;
    wahlMalen();
    stufeZeigen(stand.stufe);   /* zeichnet in Stufe 2 die Sorten */
    schuberMalen();
  }).catch(function () {
    boxLaedt = false;
    schuberMalen();
    var laedt = $('[data-gbk-laedt]');
    if (laedt) laedt.textContent = 'Die Sachen lassen sich grad ned laden – lad die Seite bitte no amal.';
  });
})();
